var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 20.6248C16.125 21.9998 14.7187 23.1248 13 23.1248C12.1458 23.1248 11.3542 22.8414 10.7917 22.3914C10.2292 21.9414 9.875 21.3081 9.875 20.6248",
    fill: "#06DF70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 20.6248C16.125 21.9998 14.7187 23.1248 13 23.1248C12.1458 23.1248 11.3542 22.8414 10.7917 22.3914C10.2292 21.9414 9.875 21.3081 9.875 20.6248",
    stroke: "#06DF70",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0209 3.03125C9.57295 3.03125 6.77086 5.83333 6.77086 9.28125V12.2917C6.77086 12.9271 6.50003 13.8958 6.17711 14.4375L4.9792 16.4271C4.23961 17.6563 4.75003 19.0208 6.1042 19.4792C10.5938 20.9792 15.4375 20.9792 19.9271 19.4792C21.1875 19.0625 21.7396 17.5729 21.0521 16.4271L19.8542 14.4375C19.5417 13.8958 19.2709 12.9271 19.2709 12.2917V9.28125C19.2709 5.84375 16.4584 3.03125 13.0209 3.03125Z",
    stroke: "#1C2A52",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9489 3.33325C14.626 3.2395 14.2926 3.16659 13.9489 3.12492C12.9489 2.99992 11.9906 3.07284 11.0947 3.33325C11.3968 2.56242 12.1468 2.02075 13.0218 2.02075C13.8968 2.02075 14.6468 2.56242 14.9489 3.33325Z",
    stroke: "#1C2A52",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.bc014a5f.svg";
export { ForwardRef as ReactComponent };